import pgwyClient from "@/api/pgwyClient";

const Registrations = {
  state: {
    registrations: null,
    searchParameters: {
      procid: null,
      searchLimit: 10,
      searchOffset: 1
    }
  },
  mutations: {
    setRegistrationSearchParameters(state, searchParameters) {
      const mandatory = {
        procid: state.searchParameters.procid,
        searchLimit: state.searchParameters.searchLimit,
        searchOffset: state.searchParameters.searchOffset
      }
      state.searchParameters = { ...mandatory, ...searchParameters };
    },
    setRegistrations(state, registrations) {
      state.registrations = registrations;
    }
  },
  actions: {
    async updateRegistrationSearchParams({ dispatch, commit, state }, searchParameters) {
      let requireUpdate = Object.keys(searchParameters).concat(Object.keys(state.searchParameters))
          .some((key) => !["searchLimit", "searchOffset"].includes(key) &&
              searchParameters[key] !== state.searchParameters[key]);

      commit("setRegistrationSearchParameters", searchParameters);
      if (requireUpdate) {
        await dispatch("updateRegistrations");
      }
    },
    async updateRegistrations({ dispatch, commit, state}) {
      try {
        const params = {...state.searchParameters};
        delete params.procid;
        delete params.protocol;
        delete params.searchLimit;
        delete params.searchOffset;

        const protocol = (await dispatch('updateProcedures')).find((procedure) =>
            procedure.procid === state.searchParameters.procid)?.protocol;

        let registrations = [];
        if (protocol) {
          const res = await pgwyClient.getRegistrations(state.searchParameters.procid, protocol, params);
          registrations = res.data.registrations;
        }

        commit("setRegistrations", registrations);
      } catch (err) {
        commit("setRegistrations", []);
        throw err;
      }
    }
 },
  getters: {
    getRegistrations(state) {
      return state.registrations;
    },
    getRegistrationSearchParams(state) {
      return state.searchParameters;
    },
  },
};

export default Registrations;
